import { Component, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import DetailLayout from '@/components/DetailLayout.vue';
import FileUpload from '@/components/FileUpload.vue';
import DraggableTable from '@/components/DraggableTable.vue';
import DraggableList from '@/components/DraggableList.vue';
import AddressField from '@/components/AddressField.vue';
import FileField from '@/components/FileField.vue';
import FileSetField from '@/components/FileSetField.vue';

@Component({
  components: {
    DetailLayout,
    FileUpload,
    DraggableTable,
    DraggableList,
    AddressField,
    FileField,
    FileSetField
  }
})
export default class DetailMixin extends Mixins(CommonMixin) {}
